angular.module('impactx.list').directive('ixListStringFilter', function(){
    return {
        restrict: 'E',
        scope: {
            header: '='
        },
        require: '^stTable',
        templateUrl: 'shared/list/templates/listfilter.tmpl.html',
        link: function (scope, element, attr, ctrl) {
            scope.change = function change () {
                ctrl.search(scope.header.value, scope.header.filterField);
            };
            scope.clear = function() {
                scope.header.value = '';
                ctrl.search(scope.header.value, scope.header.filterField);
            };
            if (scope.header.value)
            {
                ctrl.search(scope.header.value, scope.header.filterField);
            }
        }
    }
});